import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AddFilterTypePage() {
  const navigate = useNavigate();

  const options = [
    { key: 'alk', label: 'Add Alk Config', desc: 'Alkaline filter configuration' },
    { key: 'ro', label: 'Add RO Config', desc: 'Reverse Osmosis membrane' },
    { key: 'sediment', label: 'Add Sediment Config', desc: 'Sediment filter configuration' },
    { key: 'carbon', label: 'Add Carbon Config', desc: 'Carbon filter configuration' },
  ];

  return (
    <div className="w-full min-h-full px-3 py-6 sm:px-6 md:px-8 max-w-4xl mx-auto">
      <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-6">
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800">Add Configuration</h1>
          <p className="text-sm text-gray-500">Choose a filter type to create a new configuration</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {options.map((opt) => (
            <div
              key={opt.key}
              className="border border-gray-200 rounded-xl p-4 sm:p-5 flex flex-col justify-between gap-3 hover:shadow-md hover:border-indigo-200 transition-all cursor-pointer bg-white"
              onClick={() => navigate(`/filter-confs/add/${opt.key}`)}
            >
              <div>
                <div className="text-lg font-semibold text-gray-800">{opt.label}</div>
                <div className="text-sm text-gray-500 mt-1">{opt.desc}</div>
              </div>
              <div className="pt-2">
                <button
                  className="w-full sm:w-auto px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
                  onClick={(e) => { e.stopPropagation(); navigate(`/filter-confs/add/${opt.key}`); }}
                >
                  Create {opt.key}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
